import React from 'react';
import ServiceTemplate from './ServiceTemplate';

const FliesenNaturstein = () => {
  const pageData = {
    title: 'FLIESEN & NATURSTEIN',
    subtitle: 'Professionelle Verlegung',
    description: 'Hochwertige Fliesen- und Natursteinarbeiten für Bad, Küche und Wohnbereiche. Präzision und Qualität für zeitlose Eleganz in Ihrem Zuhause.',
    heroImage: 'https://images.unsplash.com/photo-1759223607861-f0ef3e617739?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHx0aWxlJTIwaW5zdGFsbGF0aW9uJTIwYmF0aHJvb20lMjBtYXJibGUlMjBuYXR1cmFsJTIwc3RvbmUlMjBmbG9vcnxlbnwwfHx8fDE3Nzc2NDMxODl8MA&ixlib=rb-4.1.0&q=85',
    features: [
      { title: 'Bodenfliesen', description: 'Robuste Fliesen für stark beanspruchte Bereiche.' },
      { title: 'Wandfliesen', description: 'Elegante Wandverkleidungen für Bad und Küche.' },
      { title: 'Naturstein', description: 'Marmor, Granit, Schiefer und andere Natursteine.' },
      { title: 'Mosaikarbeiten', description: 'Dekorative Mosaikverlegung für besondere Akzente.' },
      { title: 'Großformate', description: 'XXL-Fliesen für moderne, fugenreduzierte Optik.' },
      { title: 'Terrassenplatten', description: 'Frostbeständige Platten für den Außenbereich.' }
    ],
    benefits: [
      'Meisterhafte Verlegequalität',
      'Beratung bei Materialauswahl',
      'Präzise Fugentechnik',
      'Abdichtung nach Norm',
      'Erfahrung mit allen Formaten',
      'Saubere Baustelle garantiert'
    ],
    process: [
      { title: 'Planung', description: 'Aufmass, Materialberatung und Verlegeplan.' },
      { title: 'Vorbereitung', description: 'Untergrundprüfung und Abdichtungsarbeiten.' },
      { title: 'Verlegung', description: 'Fachgerechte Verlegung mit präziser Ausrichtung.' },
      { title: 'Verfugung', description: 'Professionelles Verfugen und Versiegeln.' }
    ],
    gallery: [
      'https://images.unsplash.com/photo-1668911094844-527491335108?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwzfHx0aWxlJTIwaW5zdGFsbGF0aW9uJTIwYmF0aHJvb20lMjBtYXJibGUlMjBuYXR1cmFsJTIwc3RvbmUlMjBmbG9vcnxlbnwwfHx8fDE3Nzc2NDMxODl8MA&ixlib=rb-4.1.0&q=85',
      'https://images.unsplash.com/photo-1656646523907-97b094c7e63a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHx0aWxlJTIwaW5zdGFsbGF0aW9uJTIwYmF0aHJvb20lMjBtYXJibGUlMjBuYXR1cmFsJTIwc3RvbmUlMjBmbG9vcnxlbnwwfHx8fDE3Nzc2NDMxODl8MA&ixlib=rb-4.1.0&q=85'
    ],
    metaKeywords: 'Fliesenleger Graubünden, Naturstein Cazis, Fliesen verlegen Schweiz, Marmor Bad'
  };

  return <ServiceTemplate {...pageData} />;
};

export default FliesenNaturstein;
